import {ResignStatus} from '@/Constant';
import toast, {ToastType} from '@/components/Toast';
import {COMMON_USE_KNOWLEDGE_TYPE} from '@/constants/home';
import sdk from '@/sdk';
import {WizKnownError} from '@/sdk/common/error';
import * as store from '@/store';
import {useEffect, useState} from 'react';

const routerPublicPath = process.env.REACT_APP_ROUTER_PUBLIC_PATH || '';

type IType = typeof COMMON_USE_KNOWLEDGE_TYPE[keyof typeof COMMON_USE_KNOWLEDGE_TYPE];

const addToastError = (error: any) => {
    if (error instanceof WizKnownError) {
        const returnCode = error.toResult().returnCode;
        if (returnCode && returnCode !== 500 && returnCode !== 'WizErrorNetwork') {
            toast({content: error.message, type: ToastType.Error});
            return;
        }
    }
    toast({content: '添加失败, 网络故障请重试', type: ToastType.Error});
};

const updateData = (type: IType, isAdd: boolean) => {
    if (type === COMMON_USE_KNOWLEDGE_TYPE.repository) {
        const repo = store.getCurRepository();
        repo && store.setCurRepository({
            ...repo,
            homepage: isAdd,
        });
    } else {
        const doc = store.getCurDocument();
        doc && store.setCurDocument({
            ...doc,
            homepage: isAdd,
        });
    }
};

export const cancelAddToCommonKnowledge = async ({
    spaceGuid,
    groupGuid,
    repositoryGuid,
    docGuid,
    callBack,
}: {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid?: string;
    callBack?: () => void;
}) => {
    try {
        await sdk.as.removeCommonUseKnowledge({
            knowledge: [{
                spaceGuid,
                groupGuid,
                repoGuid: repositoryGuid,
                docGuid,
            }],
        });
        toast({
            content: '移出成功',
            type: ToastType.Success,
        });
        if (callBack) {
            callBack();
        } else {
            updateData(
                docGuid ? COMMON_USE_KNOWLEDGE_TYPE.document : COMMON_USE_KNOWLEDGE_TYPE.repository,
                false
            );
        }
    } catch (error: any) {
        addToastError(error);
    }
};

export const addToCommonKnowledge = async ({
    type,
    callBack,
}: {
    type: IType;
    callBack?: () => void;
}) => {
    try {
        await sdk.as.addCommonUseKnowledge({
            url: location.href,
        });
        toast({
            content: '添加成功',
            type: ToastType.Success,
        });
        if (callBack) {
            callBack();
        } else {
            updateData(type, true);
        }
    } catch (error: any) {
        addToastError(error);
    }
};


export const useIsAddedToCommonKnowledge = (data?: WizDocument | Repository | null) => {
    const [isAdded, setIsAdded] = useState(false);
    const [isShow, setIsShow] = useState(true); // 新版首页展示【添加至快捷访问】，ABTest已下掉，默认值改为true

    useEffect(() => {
        setIsAdded(!!data?.homepage);
    }, [data?.homepage]);

    return [isAdded, isShow];
};


export const isHomePage = (pathname: string) => {
    return (pathname === '/') || (
        routerPublicPath
            ? (pathname.replaceAll('/', '') === routerPublicPath.replaceAll('/', ''))
            : false);
};

export function curUserHaveRlId() {
    return !!sdk.as.user?.rlId;
}

export function isDemissionUser(resignStatus?: ResignStatus) {
    if (!resignStatus) {
        return '';
    }
    const resignCont = resignStatus && resignStatus === ResignStatus.noOnJob ? '（已离职）' : '';
    return resignCont;
}
